import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {
  ChannelLimitation,
  ChannelStatus,
  CommonConstant,
  FacebookAuthPreviousState,
  platformIconPath
} from '../../app.constants';
import {Platform} from '../../../models/platform';
import {Channel} from '../../../models/common';
import {WebUtils} from '../../utils/web.utils';
import {ReferenceDataService} from '../../services/reference-data/reference-data.service';
import {InfluencerService} from '../../services/influencer/influencer.service';
import {ActivatedRoute} from '@angular/router';
import {UserService} from '../../services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {ModalService} from '../../services/modal/modal.service';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';
import {ErrorTemplate} from '../../../models/ErrorTemplate';
import {ValidationHandlerService} from '../../core/validation-handler.service';
import {InfluencerChannelAuthorization} from '../../../models/authorize-channel';
import {AuthService} from '../../core/auth.service';
import {PlatformFieldComponent} from '../influencer-settings/platform-field/platform-field.component';
import {
  ActionDetails, ActionSource,
  EventTrackerService, Page, TargetType,
  UserActionType
} from '../../services/event-tracker/event-tracker.service';

@Component({
  selector: 'campaign-acception-popup',
  templateUrl: './campaign-acception-popup.component.html',
  styleUrls: ['./campaign-acception-popup.component.scss']
})
export class CampaignAcceptionPopupComponent implements OnInit, OnChanges {
  @ViewChild('AlertRemoveSocial') alertRemoveSocial: AchooPopupComponent;
  @ViewChild('AlertRemoveSocialMobile') alertRemoveSocialMobile: AchooPopupComponent;
  @ViewChildren(PlatformFieldComponent) channelComponents: QueryList<PlatformFieldComponent>;
  @Input() channelList: Channel[];
  @Input() activePage: string;
  @Output() confirmChannel = new EventEmitter<any>();

  public readonly maxChannelCanAdded = ChannelLimitation.MAX_CHANNEL_ADDED;
  public channelErrors: ErrorTemplate[] = [];

  public platforms: Array<Platform> = [];
  public selectedChannels: any;
  public listExistingChannel: Channel[] = [];
  public listNewChannel: Channel[] = [];
  public isExceedLimtitation: boolean;
  public currentInfluencer: any;
  protected deletedChannel;
  protected newChannelIndex = 0;
  protected deleteChannelWarningPopupRef;
  protected fbAuthError: string;
  protected previousAuthorizedChannels: number[];
  protected authorizingIgChannelId: number;
  protected authorizingNewIgChannelIndex: number;
  private campaignId: number;
  private accessToken: string;
  private inviteToken: string;
  private permissionToken: string;

  constructor(protected auth: AuthService,
              protected influencerService: InfluencerService,
              protected referenceDataService: ReferenceDataService,
              protected validationHandlerService: ValidationHandlerService,
              protected activatedRoute: ActivatedRoute,
              protected userService: UserService,
              protected modalService: ModalService,
              protected eventTracker: EventTrackerService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.channelList && changes.channelList.previousValue && changes.channelList.currentValue) {
      this.listExistingChannel = changes.channelList.currentValue;
      if (this.fbAuthError) {
        setTimeout(() => {
          this.handleFbAuthOnError();
        }, 200);
      } else {
        this.handleFbAuthOnSuccess();
      }
    }
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      this.campaignId = Number(params.campaignId);
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      this.accessToken = params.accessToken;
      this.inviteToken = params.inviteToken;
      this.permissionToken = params.permissionToken;
      this.fbAuthError = params.error;
    });
    this.currentInfluencer = this.userService.getInfluencerInfo();
    this.platforms = this.referenceDataService.platforms;
    this.listExistingChannel = this.channelList;
    this.intializedChannelListFromLocalData();
  }

  protected intializedChannelListFromLocalData() {
    // get list new channel from caching data
    const localChannelAuthData = this.auth.getInfluencerChannelAuthorizationLocalData();
    if (!localChannelAuthData) {
      return;
    }
    if (localChannelAuthData.activeChannelId > 0) {
      this.authorizingIgChannelId = localChannelAuthData.activeChannelId;
    } else {
      this.authorizingNewIgChannelIndex = localChannelAuthData.activeChannelIndex;
    }
    this.previousAuthorizedChannels = localChannelAuthData.channelList.filter(ch => ch.id > 0).map(c => c.id);
    // on error show all previous new channels
    if (this.fbAuthError) {
      this.listNewChannel = localChannelAuthData.channelList.filter(cn => cn.id === 0)
        .map(c => Object.assign({}, c, {
          type: ChannelStatus.UNAUTHORIZE
        }));
      const newChannelAuthorizing = this.listNewChannel.find(c => c.index === localChannelAuthData.activeChannelIndex);
      if (newChannelAuthorizing) {
        newChannelAuthorizing.type = ChannelStatus.AUTHORIZE_FAILED;
      }
    } else {
      // on success, remove the previous success one
      this.listNewChannel = localChannelAuthData.channelList.filter(cn => cn.id === 0 && cn.index !== localChannelAuthData.activeChannelIndex);
    }
  }

  protected handleFbAuthOnError() {
    let fieldError;
    let channelComp;
    if (this.authorizingIgChannelId > 0) {
      fieldError = this.authorizingIgChannelId.toString();
      channelComp = this.channelComponents.find(c => c.channelData.id === this.authorizingIgChannelId);
    } else {
      fieldError = `new_${this.authorizingNewIgChannelIndex}`;
      channelComp = this.channelComponents.find(c => c.channelData.index === this.authorizingNewIgChannelIndex);
    }
    if (channelComp) {
      channelComp.platformSetting.status = ChannelStatus.AUTHORIZE_FAILED;
    }
    this.handleChannelError(fieldError, this.fbAuthError);
  }

  private handleFbAuthOnSuccess() {
    if (this.authorizingIgChannelId > 0) {
      this.auth.saveAuthorizedChannelOnLocal(this.authorizingIgChannelId);
      const authorizedIgChannel = this.listExistingChannel.find(c => this.authorizingIgChannelId === c.id);
      // send MP event after authorizing IG channel
      if (authorizedIgChannel) {
        this.sendMpEvent(authorizedIgChannel.id, authorizedIgChannel.handle);
      }
    } else if (Array.isArray(this.previousAuthorizedChannels) && this.previousAuthorizedChannels.length > 0) {
      const authorizingChannel = this.listExistingChannel.find(c => this.previousAuthorizedChannels.indexOf(c.id) < 0);
      if (authorizingChannel) {
        // send MP event after authorizing IG channel
        this.auth.saveAuthorizedChannelOnLocal(authorizingChannel.id);
        this.sendMpEvent(authorizingChannel.id, authorizingChannel.handle);
      }
    }
  }

  onModifyChannel(evt) {
    if (evt.status === 'error') {
      // TODO will show error message following the new Mockup
      console.log(`has error while adding channel ${evt.errorCode}`);
      this.handleChannelError(evt.fieldError, evt.errorCode);
    } else {
      // clear error
      this.channelErrors = this.channelErrors.filter(ce => ce.name !== evt.fieldName);
      this.updateErrors(this.channelErrors);
      this.sendMpEvent(evt.data.id, evt.data.handle);
      setTimeout(() => {
        this.reLoadInfluencerChannels(this.currentInfluencer.id, () => {
          if (evt.type === 'new') {
            this.listNewChannel = this.listNewChannel.filter(nc => nc.handle !== evt.data.handle);
          }
        });
      }, 400);
    }
  }

  private sendMpEvent(channelId, handle) {
    const target = {
      type: TargetType.CHANNEL,
      id: channelId,
      name: handle
    };
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CHANNEL, target, {
      actionDetails: ActionDetails.INFLUENCER_CONFIRM_CHANNEL,
      source: this.accessToken ? ActionSource.CAMPAIGN_LANDING_PAGE : ActionSource.INFLUENCER_APP,
      action: UserActionType.UPDATE
    }, undefined, null);
  }

  protected handleChannelError(fieldError, errorCode) {
    const existedError = this.channelErrors.find(ce => ce.name === fieldError);
    if (existedError) {
      existedError.message = this.getMessageErrorKey(errorCode);
    } else {
      this.channelErrors.push({
        name: fieldError,
        message: this.getMessageErrorKey(errorCode)
      });
    }
    this.updateErrors(this.channelErrors);
  }

  private updateErrors(errors: ErrorTemplate[]) {
    this.validationHandlerService.updateErrors(errors);
    this.validationHandlerService.shouldDisplayErrors(true);
  }

  private getMessageErrorKey(errorCode) {
    if (errorCode === CommonConstant.INFLUENCER_HANDLE_EXISTED) {
      return 'influencer_request.errors.handle_existed';
    } if (errorCode === CommonConstant.NO_BUSSINES_USER_ERROR) {
      return 'influencer_request.errors.no_business_user';
    } if (errorCode === CommonConstant.FACEBOOK_ERROR) {
      return 'influencer_request.errors.facebook_error';
    } if (errorCode === CommonConstant.INVALID_TOKEN) {
      return 'influencer_request.errors.invalid_token';
    } if (errorCode === CommonConstant.MISSING_TOKEN) {
      return 'influencer_request.errors.missing_token';
    } if (errorCode === CommonConstant.MISSING_CHANNEL) {
      return 'influencer_request.errors.missing_channel';
    } if (errorCode === CommonConstant.INVALID_CHANNEL) {
      return 'influencer_request.errors.invalid_channel';
    } if (errorCode === CommonConstant.NOT_OWN_CHANNEL) {
      return 'influencer_request.errors.not_own_channel';
    } if (errorCode === CommonConstant.CHANNEL_OWNED_BY_OTHERS) {
      return 'influencer_request.errors.channel_owned_by_others';
    } if (errorCode === CommonConstant.TOO_MANY_POSTS_TO_MERGE_OR_STEAL) {
      return 'influencer_request.errors.too_many_posts_to_merge_or_steal';
    } else {
      return 'influencer_request.errors.auth_fail';
    }
  }

  private reLoadInfluencerChannels(influencerId, callback) {
    this.influencerService.getInfluencerChannels(influencerId).subscribe((res) => {
      this.listExistingChannel = res;
      if (callback) {
        callback();
      }
    });
  }

  authorizeChannel(evt) {
    if ((evt.channel === 'ig')) {
      const authData = new InfluencerChannelAuthorization();
      authData.campaignId = this.campaignId;
      authData.isAuthenticatedIGChannel = this.hasSelectedIGChannel;
      authData.accessToken = this.accessToken;
      authData.inviteToken = this.inviteToken;
      authData.permissionToken = this.permissionToken;
      authData.channelList = this.listChannel;
      authData.activeChannelId = evt.data.id;
      authData.activeChannelIndex = evt.data.index;
      this.auth.saveInfluencerChannelAuthorizationDataOnLocal(authData);
      if (authData.activeChannelId > 0) {
        this.auth.saveAuthorizedChannelOnLocal(authData.activeChannelId);
      }

      const currentUser = this.auth.getUser();
      if (currentUser) {
        const facebookAuthLink = WebUtils.igChannelAuthorizationLink(evt.data.id, this.currentInfluencer.id,
          evt.data.handle, currentUser.token, this.activePage);
        window.location.href = facebookAuthLink;
      }
    } else {
      this.onModifyChannel(evt);
    }
  }

  get listChannel() {
    const listChannel = [];
    listChannel.push(...this.listExistingChannel);
    listChannel.push(...this.listNewChannel);
    return listChannel;
  }

  afterChangePlatform(evt) {
    if (this.listChannel && this.listChannel.length > ChannelLimitation.MAX_CHANNEL_ADDED) {
      this.isExceedLimtitation = true;
    } else if (this.selectedChannels) {
      this.listNewChannel.push({
        id: 0,
        handle: null,
        blogId: this.currentInfluencer.id,
        type: ChannelStatus.UNAUTHORIZE,
        relativePath: null,
        platform: this.platforms.find(pl => pl.id === this.selectedChannels),
        youtubeType: null,
        index: this.newChannelIndex++
      });
      if (this.listChannel && this.listChannel.length > ChannelLimitation.MAX_CHANNEL_ADDED) {
        this.listNewChannel.pop();
        this.isExceedLimtitation = true;
      } else {
        this.selectedChannels = null;
        this.isExceedLimtitation = false;
      }
    }
  }

  onDeleteChannel(evt) {
    this.deletedChannel = evt;
    if (evt.isMobile) {
      this.deleteChannelWarningPopupRef = this.modalService.openInCenter(this.alertRemoveSocialMobile, () => {
        this.deletedChannel = null;
      }, 'channel-auth-modal');
    } else {
      this.deleteChannelWarningPopupRef = this.modalService.openInCenter(this.alertRemoveSocial, () => {
        this.deletedChannel = null;
      });
    }
  }

  closeDeleteChannelWarningPopup() {
    this.deletedChannel = null;
    this.modalService.closeSinglePopup(this.deleteChannelWarningPopupRef);
  }

  onChangeHandle(evt) {
    this.channelErrors = this.channelErrors.filter(ce => ce.name !== evt.fieldName);
  }

  acceptDeleteChannel() {
    this.onCloseConfirmPopupBeforeDeletingChannel();
    this.isExceedLimtitation = false;
    // clear error on UI
    this.clearSpecificChannelError(this.deletedChannel.channel);
    // process to delete channel
    const deleteChannelId = this.deletedChannel.channel.id;
    // when deleting an new channel which doesn't save.
    if (deleteChannelId === 0) {
      this.listNewChannel = this.listNewChannel.filter(nc => nc.index !== this.deletedChannel.channel.index);
      return;
    }
    // keep the removed channel to rever if error happen
    const removedChannelIndex = this.listExistingChannel.findIndex(c => c.id === deleteChannelId);
    const removedChannel = this.listExistingChannel[removedChannelIndex];
    // optimitis UI
    this.listExistingChannel = this.listExistingChannel.filter(c => c.id !== deleteChannelId);
    this.influencerService.deleteInfluencerChannel(deleteChannelId).subscribe((res) => {
    }, (err) => {
      // revert the change before
      this.listExistingChannel.splice(removedChannelIndex, 0, removedChannel);
    });
  }

  private clearSpecificChannelError(channel) {
    if (channel.id > 0) {
      this.channelErrors = this.channelErrors.filter(ce => ce.name !== String(channel.id));
    } else {
      this.channelErrors = this.channelErrors.filter(ce => ce.name !== `new_${channel.index}`);
    }
    this.validationHandlerService.updateErrors(this.channelErrors);
  }

  onCloseConfirmPopupBeforeDeletingChannel() {
    if (this.deleteChannelWarningPopupRef) {
      this.modalService.closeSinglePopup(this.deleteChannelWarningPopupRef);
    }
  }

  onConfirm() {
    this.confirmChannel.emit(this.listChannel);
  }

  get hasSelectedIGChannel() {
    return this.listChannel.findIndex(newCN => newCN.platform.id === platformIconPath.instagram.id) >= 0;
  }

  get numberOfAddedChannels() {
    return this.listChannel.length;
  }

  get isValidToSubmit() {
    return this.listChannel && this.listChannel.length > 0 && this.listChannel.filter(cn => cn.type !== ChannelStatus.AUTHORIZED).length === 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/influencer-platform/campaign-acception-popup/campaign-acception-popup.component.ts